<template>
  <div class="">

    <Loading :show="!texts.length" />

    <div class="admin-sub-nav">
      <ul>
        <li :class="cat === category ? 'active' : ''"  v-for="cat in categories"><a @click.stop.prevent="setCat(cat)" href="#">{{cats[cat] || cat}}</a></li>
        <li class="language-selector" v-if="category === 'skischoolgroup'" :style="'background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/' + flag + '.svg);'">
          <select id="language" v-model="selectedLanguage">
            <option v-for="lang in languages" :key="lang" :value="lang">{{ lang }}</option>
          </select>
        </li>
      </ul>
    </div>

    <div class="admintextcontainer">

      <h1>Texter</h1>

      <hr />

      <table v-if="category === 'accomodationaddon'">
        <thead>
          <tr>
            <th>Pool-ID</th>
            <th>Rubrik</th>
            <th>Bild</th>
            <th></th>
            <th>Beskrivning</th>
            <th>Plural</th>
            <th>Kopplad produkt</th>
            <th>Obl. städ</th>
          </tr>
        </thead>
        <tbody v-for="text in texts" v-if="text.category === category">
          <tr>
            <td><input type="number" @change="updateText(text)" v-model="text.id1" /></td>
            <td><textarea @change="updateText(text)" v-model="text.text1"></textarea></td>
            <td><input type="text" @change="updateText(text)" v-model="text.text2" /></td>
            <td><img v-if="text.text2" style="height:2em;" :src="'https://static.booking.branasgruppen.se/static/svg/addons/' + text.text2" /></td>
            <td><textarea @change="updateText(text)" v-model="text.text3"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text6"></textarea></td>
            <td><input type="number" @change="updateText(text)" v-model.number="text.text4" /></td>
            <td><input type="number" @change="updateText(text)" v-model="text.text7" /></td>
          </tr>
        </tbody>
        <tbody>
          <tr><td colspan="6" style="text-align:center; padding: 2em;"><button @click="add">Lägg till</button></td></tr>
        </tbody>
      </table>

      <table v-if="category === 'pagetexts'">
        <thead>
          <tr>
            <th>Kategori</th>
            <th>Nyckel</th>
            <th>Text</th>
          </tr>
        </thead>
        <tbody v-for="text in texts" v-if="text.category === category">
          <tr>
            <td><input type="text" @change="updateText(text)" v-model="text.slug" /></td>
            <td><input type="text"  @change="updateText(text)" v-model="text.text1" /></td>
            <td><textarea @change="updateText(text)" v-model="text.text2" rows="10"></textarea></td>
          </tr>
        </tbody>
        <tbody>
          <tr><td colspan="3" style="text-align:center; padding: 2em;"><button @click="add">Lägg till</button></td></tr>
        </tbody>
      </table>

      <table v-if="category === 'skilettingproduct'">
        <thead>
          <tr>
            <th>Pool-ID</th>
            <th>Rubrik</th>
            <th>Bild</th>
            <th></th>
            <th>{{ 'Underrubrik' }}</th>
            <th>{{ 'Beskrivning' }}</th>
            <th>Underrubrik<br>ny skidhyra</th>
            <th>Bild (m. hjälm)</th>
            <th>{{ 'Kortare rubrik' }}</th>
          </tr>
        </thead>
        <tbody v-for="text in texts" v-if="text.category === category">
          <tr>
            <td><input type="number" @change="updateText(text)" v-model="text.id1" /></td>
            <td><textarea @change="updateText(text)" v-model="text.text1"></textarea><br/>{{text.original}}<br>{{text.meta}}</td>
            <td><textarea @change="updateText(text)" v-model="text.text2"></textarea></td>
            <td><img v-if="text.text2" style="height:2em;" :src="'https://static.booking.branasgruppen.se/static/img/produkter/' + text.text2" /></td>
            <td><textarea @change="updateText(text)" v-model="text.text3"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text4"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text7"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text5"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text6"></textarea></td>
          </tr>
        </tbody>
        <tbody>
          <tr><td colspan="9" style="text-align:center; padding: 2em;"><button @click="add">Lägg till</button></td></tr>
        </tbody>
        <tbody>
          <tr><td colspan="9"><h2 style="margin-top: 3rem;">Produkter utan texter...</h2></td></tr>
        </tbody>
        <tbody v-for="text in missingTexts" v-if="text.category === category">
          <tr>
            <td>{{ text.id1 }}</td>
            <td>{{text.original}} | {{text.meta}}</td>
            <td colspan="7">&nbsp;</td>
          </tr>
        </tbody>
      </table>

      <table v-if="category === 'skischoolgroup'">
        <thead>
          <tr>
            <th>Grupp</th>
            <th>Rubrik</th>
            <th>Text</th>
            <th>Förkunskaper</th>
            <th>Bildrubrik</th>
          </tr>
        </thead>
        <tbody v-for="text in texts" v-if="text.category === category">
          <tr>
            <td>{{ friendlySkiSchoolGroupId(text.id1) }}</td>
            <td><textarea @change="updateText(text)" v-model="text.text1[selectedLanguage]"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text2[selectedLanguage]"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text3[selectedLanguage]"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text4[selectedLanguage]"></textarea></td>
          </tr>
        </tbody>
        <tbody>
          <tr><td colspan="9" style="text-align:center; padding: 2em;"><button @click="add">Lägg till</button></td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import API from '@/classes/API';
import Loading from '@/components/components/Loading';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      texts: [],
      missingTexts: [],
      categories: [],
      category: '',
      cats: {
        accomodationaddon: 'Boendetillval',
        pagetexts: 'Sidtexter',
        skilettingproduct: 'Skidhyra',
        skischoolgroup: 'Skidskolegrupp',
      },
      selectedLanguage: 'sv',
      languages: ['sv', 'en', 'da'],
    };
  },
  async mounted() {
    const { data, categories, missingTexts } = await API.get('/texts');
    this.texts = data.map((text) => {
      if (text.category === 'skischoolgroup') {
        const newText = Object.assign({}, text);
        ['text1', 'text2', 'text3', 'text4'].forEach((field) => {
          newText[field] = JSON.parse(newText[field] || '{}') || '';
        });
        return newText;
      }
      return text;
    });
    this.categories = categories;
    this.setCat(categories[0]);
    this.missingTexts = missingTexts;
  },
  computed: {
    flag() {
      let flagUrl = '';
      this.SITE_CONFIG.languages.full.forEach((lang) => {
        if (lang.value === this.selectedLanguage) {
          flagUrl = lang.flag;
        }
      });

      return flagUrl;
    },
  },
  methods: {
    friendlySkiSchoolGroupId(id) {
      // Replace all dots with ", " "-" " år," and ", "
      return id
        .replace(/\./, '#1')
        .replace(/\./, '-')
        .replace(/\./, ' år')
        .replace('group#1', 'Grupp, ')
        .replace('private#1', 'Privat, ')
        .replace('snowboard#1', 'Snowboard, ')
        .replace(' årgreen', ' år, nivå 1')
        .replace(' årblue', ' år, nivå 2')
        .replace(' årred_snolek', ' år, snölek')
        .replace(' årred', ' år, nivå 3')
        .replace(' år_private_1', ' år, nivå 1')
        .replace(' år_private_2', ' år, nivå 2')
        .replace(' år_private_3', ' år, nivå 3')
        .replace(' år_private_', ' år, privat')
        .replace(' årblack', ' år, nivå 4');
    },
    setCat(cat) {
      this.category = cat;
    },
    add() {
      this.texts.push({
        category: this.category,
        slug: '',
        id1: '',
        id2: '',
        id3: '',
        text1: '',
        text2: '',
        text3: '',
        text4: '',
        text5: '',
        text6: '',
        text7: '',
      });

      this.$toast.warning('OBS! Sparas inte förrän du skrivit något', 'Tillagd text', {
        position: 'topRight',
      });
    },
    async updateText(text) {
      const { error, data } = await API.post('/admin/update-texts', text);

      if (error) {
        this.$toast.error(error, 'Fel', {
          position: 'topRight',
        });
        return;
      }

      text.id = data.id; // eslint-disable-line

      this.$toast.success('Texten sparades', 'Sparat', {
        position: 'topRight',
      });
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.admintextcontainer
  admin-container()

.admin-sub-nav
  admin-sub-nav()

table
  width 100%
th, td
  text-align left
  padding 2px 5px
  border-bottom 1px solid lightgrey
  vertical-align: top
  input
    font-weight normal
    &[type="number"]
      width 60px
    &[type="text"]
      width 200px !important
  textarea
    width 200px
tbody tr:last-child td
  padding-bottom 20px
input
  pading 2px 5px
.language-selector
  align-items center
  display: flex
  padding-left 2rem
  background-size 1rem
  background-repeat no-repeat
  background-position 0.5rem center
</style>



// WEBPACK FOOTER //
// Texts.vue?e82180d0